import {makeStyles} from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    // alignItems: 'center',
    minHeight:330
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  googleBtn:{
    background:'#E02323',
    color:'#fff'
  },
  fbBtn:{
    background:'#2B59B2',
    color:'#fff'
  }

}));
